import type {ISettingsSetter} from '@wix/tpa-settings'
import {useSettings as useYoshiSettings} from '@wix/tpa-settings/react'
import {WidgetType, useSettingsBi} from '../../../settings-commons/hooks/use-settings-bi'

export const useSettings = () => {
  const settings = useYoshiSettings()
  const {debouncedEditorEventsWidgetSettingChanged} = useSettingsBi(WidgetType.EventSchedule)

  const set: ISettingsSetter = (param, value) => {
    debouncedEditorEventsWidgetSettingChanged(param.key, value)
    settings.set(param, value)
  }

  return {
    ...settings,
    get: settings.get,
    set,
  }
}
